// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom'; // 'navigate' is now 'useNavigate'
// import axios from 'axios';

// const ForgetPassword = () => {
//   const [email, setEmail] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     setMessage('');

//     try {
//       await axios.post(`${API_BASE}/user/forgotPassword`, { email });
//       setMessage('Verification email sent successfully.');

//       // Store the email in localStorage
//       localStorage.setItem('forgotPasswordEmail', email);

//       navigate('/verify');
//     } catch (error) {
//       setError('Failed to send verification email. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//      <div
//       className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
//       style={{
//         backgroundImage:
//           "url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
//       }}
//     >
//       <div className="max-w-md w-full bg-white bg-opacity-95 p-5 rounded-md shadow-md border border-gray-300">
//         <h2 className="text-center text-2xl mb-6 text-gray-800">Forget Password</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-gray-700">Email</label>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//               placeholder="Enter your registered email"
//               required
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//             disabled={loading}
//           >
//             {loading ? 'Sending...' : 'Send Password Reset Email'}
//           </button>
//         </form>
//         {message && <p className="text-center text-green-500 mt-4">{message}</p>}
//         {error && <p className="text-center text-red-500 mt-4">{error}</p>}
//         <div className="text-center mt-4">
//           <p className="text-gray-700">
//             <Link to="/login">
//               <button className="text-red-500 hover:underline">
//                 Go back to Sign In
//               </button>
//             </Link>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgetPassword;
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { message } from 'antd'; // Using Antd message for notifications

// Global constant
const API_BASE = process.env.REACT_APP_API_BASE;

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    message.destroy(); // Clear any previous messages

    try {
      // NOTE: This API endpoint is often a public route and typically doesn't require a token.
      const response = await axios.post(`${API_BASE}/user/forgotPassword`, { email });

      // Check for success response (status 200 is often enough, but checking response data might be safer)
      if (response.status === 200 || response.data?.success) {
          message.success('Verification email sent successfully. Redirecting to verification page...');
      
          // Store the email in localStorage to pre-fill the verify page
          localStorage.setItem('forgotPasswordEmail', email);

          // Redirect after a slight delay for the message to show
          setTimeout(() => {
            navigate('/verify');
          }, 1500);
      } else {
          // Handle specific API errors if message is available in response body
          message.error(response.data?.message || 'Failed to send verification email. Please try again.');
      }
      
    } catch (error) {
      console.error("Forgot Password Error:", error);
      const errorMessage = error.response?.data?.message || 'Failed to send verification email. Please check the email address.';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
      style={{
        backgroundImage:
          // MF Blind style background
          "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
      }}
    >
      <div className="max-w-md w-full bg-white bg-opacity-95 p-8 rounded-lg shadow-2xl border border-gray-200">
        
        {/* MF Blind-style Header */}
        <div className="mb-6 border-b pb-4 text-center">
            <h1 className="text-xl font-bold text-green-700">MF Blind</h1>
            <h2 className="text-2xl mt-2 text-gray-800">Reset Your Password</h2>
        </div>

        <p className="text-center text-gray-600 mb-6 text-sm">
            Enter your registered email address below. We will send you a verification code or link to reset your password.
        </p>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm mb-1">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500"
              placeholder="Enter your registered email"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full py-3 bg-green-700 text-white rounded-md font-semibold hover:bg-green-800 transition duration-150 shadow-md disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Sending Request...' : 'Send Password Reset Email'}
          </button>
        </form>
        
        {/* Links (MF Blind Green Style) */}
        <div className="text-center mt-6">
          <Link to="/login" className="text-sm text-green-700 hover:text-green-900 font-medium">
            <span className="border-b border-green-700 border-opacity-50 pb-0.5">
                Go Back to Sign In
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;